import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * Adicionar a partir da grelha, sem sair da página.
 *
 * O formulário funciona sozinho se o JavaScript falhar — recarrega e leva ao
 * carrinho. Este ficheiro só evita a recarga e avisa a gaveta de que o carrinho
 * mudou, para o número no saco acompanhar.
 */
class AdicionarDaGrelha {
  constructor(form) {
    this.form = form;
    this.button = form.querySelector('button[type="submit"]');
    this.original = this.button?.textContent;
    form.addEventListener('submit', (event) => this.#enviar(event));
  }

  async #enviar(event) {
    const id = this.form.querySelector('input[name="id"]')?.value;
    if (!id || !window.Theme?.routes?.cart_add_url) return; // deixa o formulário seguir

    event.preventDefault();
    this.button.setAttribute('aria-busy', 'true');

    let adiado = null;
    try {
      adiado = CartLinesUpdateEvent.createPromise();
      this.form.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(id), quantity: 1 }],
          promise: adiado.promise,
          bubbles: true,
        })
      );
    } catch {
      // O aviso é um extra; o que não pode falhar é o produto entrar no carrinho
      adiado = null;
    }

    try {
      const resposta = await fetch(window.Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
      });

      const resultado = await resposta.json();
      if (resultado.status) throw new Error(resultado.description || resultado.message);

      const carrinho = await fetch(`${window.Theme.routes.cart_url}.js`).then((r) => r.json());

      if (adiado) {
        adiado.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrinho),
          detail: { didError: false, items: carrinho.items, source: 'claro-add', itemCount: 1 },
        });
      } else {
        // Sem o aviso, a gaveta continuaria a mostrar o carrinho antigo
        window.location.reload();
        return;
      }

      this.#confirmar();
    } catch (erro) {
      adiado?.resolve({ detail: { didError: true, source: 'claro-add' } });
      console.error('claro-add:', erro);
      this.#repor();
    }
  }

  #confirmar() {
    this.button.textContent = '✓';
    setTimeout(() => this.#repor(), 1400);
  }

  #repor() {
    this.button.textContent = this.original;
    this.button.removeAttribute('aria-busy');
  }
}

document.querySelectorAll('form[data-claro-add]').forEach((form) => new AdicionarDaGrelha(form));
